export const ApplicationRoutes = {
  dashboard: 'dashboard',
  profile: 'profile',
  receivable: 'receivable',
  contacts: 'contacts',
  shopPerformance: 'location-invoices',
  samples: 'samples',
  targets: 'targets',
  google: 'google',
  reviews: 'reviews',
  reports: 'reports',
  payments: 'payments',
  admin: 'admin',
  promotions: 'promotions',
  tires: 'tires',
  tracker: 'tracker',
  performancePackageGp: 'performance-package-gp',
  survey: 'survey',
  info: 'info',
  whoToCall: 'who-to-call',
  announcements: 'announcements',
  workOrders: 'work-orders',
  stockable: 'stockable',
  attendance: 'attendance',
  employee: 'employee',
  scheduler: 'scheduler',
  vendors: 'vendors',
  fluids: 'fluids',
  addons: 'addons',
  officialForms: 'official-forms',
  callIntelligence: 'call-intelligence',
  eventsCalendar: 'events-calendar',
  locations: 'locations',
  designSystem: 'design-system'
}
